'use client';

import { usePrint } from '@/lib/hooks';
import { PageProps, PageView } from '@/lib/types';
import { Section as AppSection, Body, Breadcrumb, ZoomImage } from '@/ui';
import { Content } from '@/widgets';
import { Container } from '@mantine/core';

type Section = PageProps & {
  data: PageView;
};

type Props = { view: Section };

export default function View({ view }: Props) {
  const { ref, handlePrint } = usePrint();

  const breadcrumbItems = [
    { title: view?.breadcrumb, href: `/general-menu/${view?.menu_id}` },
    { title: view?.data?.category_title, href: `/sections/${view?.data?.category_code}` },
  ];

  return (
    <Container>
      <AppSection rightMenu={{ isActive: true, id: view?.menu_id, activeItem: { id: view?.menu_item_id } }}>
        <Content ref={ref}>
          <Content.Header details={{ handlePrint, ageLimit: view?.data?.age_limit }}>
            <Breadcrumb items={breadcrumbItems} />
          </Content.Header>
          <Content.Title>{view?.data?.title}</Content.Title>
          <Content.Body
            className="flex flex-col gap-5"
            isShareable
            views={view?.data?.views}
            updatedAt={view?.data?.updated_date ? view?.data?.updated_date : null}
          >
            {view?.data?.body?.trim() ? (
              <ZoomImage>
                <Body content={view?.data?.body} />
              </ZoomImage>
            ) : null}
          </Content.Body>
        </Content>
      </AppSection>
    </Container>
  );
}
